module.exports = __webpack_public_path__ + "static/media/test-pyramid.d6b4f2cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/02-unit-testing/02-core-concepts/images/test-pyramid.png
// module id = 863
// module chunks = 0